<template>
<button
  v-if="$can('all.tickets.documents.print')"
  @click="handleClick()"
  class="btn btn-fill btn-wd btn-default btn-block btn-router"
>
  <span v-if="eligibleNotWinners">
    Download Tickets Reservas
  </span>
  <span v-else>
    Download Tickets Ganhadores
  </span>
</button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'btn-print-all-tickets',

  props: {
    eligibleNotWinners: {
      default: false
    }
  },

  computed: {
    ...mapGetters('events', {
      event: 'event'
    })
  },

  methods: {
    handleClick () {
      let routeData = this.$router.resolve({
        name: 'all.tickets.documents.print',
        params: {
          id: this.event._id,
          eligibleNotWinners: this.eligibleNotWinners
        }
      })
      window.open(
        routeData.href,
        'documentsWindow',
        'menubar=false,location=false,resizable=false,scrollbars=1,status=false'
      )
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnPrintAllTickets.vue